import script from "./CloudPhoneUploadDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./CloudPhoneUploadDialog.vue?vue&type=script&setup=true&lang=js"

import "./CloudPhoneUploadDialog.vue?vue&type=style&index=0&id=04146203&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04146203"]])

export default __exports__